import React from 'react';
import ReactMarkdown from 'react-markdown';
import { privacyPolicy } from '../data/legalDocs';
import './Legal.css';

function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <h1>Политика обработки персональных данных</h1>
      <div className="legal-content">
        <ReactMarkdown>{privacyPolicy}</ReactMarkdown>
      </div>
    </div>
  );
}

export default PrivacyPolicy;